import React from 'react';
import { styled } from 'styled-components';
import { zIndex } from '../../../../play-core/styles/z-index';
import { jsx as _jsx } from "react/jsx-runtime";
export const AriaTimePicker = ({
  time,
  onChange
}) => /*#__PURE__*/_jsx(StyledDatePicker, {
  children: /*#__PURE__*/_jsx(TimeInput, {
    type: 'time',
    value: time,
    onChange: ({
      target
    }) => onChange(target.value)
  })
});
export const StyledDatePicker = styled.div.withConfig({
  displayName: "AriaTimePicker__StyledDatePicker",
  componentId: "sc-3rs28a-0"
})(["position:relative;"]);
export const TimeInput = styled.input.withConfig({
  displayName: "AriaTimePicker__TimeInput",
  componentId: "sc-3rs28a-1"
})(["position:absolute;left:-100vw;z-index:", ";&.focus-visible{left:unset;}"], zIndex.calendar);